import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';

import AnswerPanel from 'models/answer_panel';
import AnswerPanelContext from 'components/customer/answer_panel/answer_panel_context';
import AnswerPanelDropdownMenu, { SortWrapper } from 'components/customer/answer_panel/lib/answer_panel_dropdown_menu';
import SetSortType from 'actions/answers/set_sort_type';
import { useExecuteAction } from 'components/hooks/connect_hooks';

const SORT_TEXT = {
  [AnswerPanel.SortType.RELEVANCE]: 'Best match',
  [AnswerPanel.SortType.FREQUENCY]: 'Most used',
};

const OPTIONS = [
  { label: SORT_TEXT[AnswerPanel.SortType.RELEVANCE], value: AnswerPanel.SortType.RELEVANCE },
  { label: SORT_TEXT[AnswerPanel.SortType.FREQUENCY], value: AnswerPanel.SortType.FREQUENCY },
];

export default function AnswerSearchSort() {
  const { sortType } = useContext(AnswerPanelContext);

  const executeAction = useExecuteAction();
  const onSelect = useCallback(
    value => {
      if (sortType !== value) {
        executeAction(SetSortType, { type: value });
      }
    },
    [sortType]
  );

  return (
    <StyledMenu>
      <AnswerPanelDropdownMenu
        data-aid="answerPanel-search-sortMenu"
        onSelect={onSelect}
        options={OPTIONS}
        text={SORT_TEXT[sortType]}
        value={sortType}
      />
    </StyledMenu>
  );
}

const StyledMenu = styled.div`
  ${SortWrapper} {
    padding: ${p => p.theme.spacing.small} ${p => p.theme.spacing.large};
  }
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/answer_panel/search/answer_search_sort.jsx